import { useEffect, useState } from 'react';

import { useVendorsHook } from '../../../Hooks/Maintenance/Vendors/vendorsHooks';

import { VendorsDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';
import { Authentication } from "../../../Models/Authentication/Authentication";

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import LocalStorageHelper from "../../../Utilities/Helpers/LocalStorageHelper";

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { VendorField, AuthenticationField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function VendorsDropdown(fieldProps: VendorsDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
        multiple,
        isUserVendorsOnly,
	} = fieldProps;
    let _userData: Authentication = LocalStorageHelper.getUserData();

	//Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 2000,
        // pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        // searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

	const q_queryKey = [CachingEnum.VENDOR, queryStr]
    const { data, fetchStatus } = useVendorsHook(q_queryKey, queryStr, true);

    const vendorProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: isUserVendorsOnly ? (_userData?.[AuthenticationField.VENDORS]?.map((item: any) => { return { id: item?.[VendorField.PUBLIC_ID] ?? "", ...item  }}) ?? []) : (data?.data?.list?.map((item: any) => { return { id: item?.[VendorField.PUBLIC_ID] ?? "", ...item  }}) ?? []), 
        isLoadingDropdown: fetchStatus == "fetching",
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        fieldClassName: fieldClassName,
        multiple: multiple,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...vendorProps} />
}
